module.exports = __webpack_public_path__ + "img/首页底部APP图.f1f2d8ee.jpg";